$(document).ready(function () {
  jQuery(".js-mobile-menu-trigger").click(function () {
    jQuery(".navigation-mobile").addClass("open");
  });

  jQuery(".js-mobile-close").click(function () {
    jQuery(".navigation-mobile").removeClass("open");
  }); 

  // jQuery(".js-announcement").slick({
  //  speed: 20000,
  //   autoplay: true,
  //   autoplaySpeed: 0,
  //   centerMode: true,
  //   cssEase: "linear",
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   variableWidth: true,
  //   infinite: true,
  //   initialSlide: 1,
  //   arrows: false,
  //   buttons: false,
  //   pauseOnHover: false,
  // });

  if (jQuery(".text-slider").length) {
    jQuery(".text-slider").slick({
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: "linear",
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false,
      pauseOnHover: false,
    });
  }

  var _mainSlide = jQuery(
    "body.page-product .gallery-big .js-gallery-main, .custom-featured-product-section:not(.lp-featured-product) .gallery-big .js-gallery-main"
  ).slick({
    dots: false,
    arrows: false,
    infinite: true,
    loop: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    swipe: true,
    fade: true,
    asNavFor: ".gallery-thumb .js-gallery-thumb",
  });

  if (jQuery('.js-gallery-thumb .gallery-item').length) {
    jQuery('.js-gallery-thumb .gallery-item').click(function(){
      _index = jQuery(this).data('index');

      _mainSlide.slick('slickGoTo', _index - 1);
    });
  }

  

  if (jQuery("section.section-main-product .gallery-thumb .js-gallery-thumb").length) {
    // "section.section-main-product .gallery-thumb .js-gallery-thumb, .custom-featured-product-section:not(.lp-featured-product) .gallery-thumb .js-gallery-thumb"
  jQuery(
    "section.section-main-product .gallery-thumb .js-gallery-thumb"
  ).slick({
    slidesToShow: 3,
    slidesToScroll: 2,
    // arrows: false,
    dots: false,
    asNavFor: ".gallery-big .js-gallery-main",
    vertical: true,
    autoplay: false,
    verticalSwiping: true,
    centerMode: false,
    infinite: true,
    loop: true
  });
  }

  

  if (jQuery(".lp-featured-product .product-wrapper .gallery-big .js-gallery-main").length) {
    jQuery(
      ".lp-featured-product .product-wrapper .gallery-big .js-gallery-main"
    ).each(function (num, elem) {
      elem = jQuery(elem);
      elem.slick({
        dots: false,
        arrows: false,
        infinite: true,
        loop: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        swipe: true,
        fade: true,
        // variableWidth: true,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
        draggable: false,
        asNavFor:
          ".lp-featured-product .product-wrapper .gallery-thumb .js-gallery-thumb.lp-card-thumbnail",
      });
    });
  }
  

  // jQuery(
  //   ".lp-featured-product .product-wrapper .gallery-big .js-gallery-main"
  // ).slick({
  //   dots: false,
  //   arrows: false,
  //   infinite: true,
  //   loop: true,
  //   speed: 300,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   adaptiveHeight: true,
  //   swipe: true,
  //   fade: true,
  //   // variableWidth: true,
  //   asNavFor:
  //     ".lp-featured-product .product-wrapper .gallery-thumb .js-gallery-thumb.lp-card-thumbnail",
  // });

  if (jQuery(".lp-featured-product .product-wrapper .gallery-thumb .js-gallery-thumb.lp-card-thumbnail").length) {
    jQuery(
      ".lp-featured-product .product-wrapper .gallery-thumb .js-gallery-thumb.lp-card-thumbnail"
    ).slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      asNavFor:
        ".lp-featured-product .product-wrapper .gallery-big .js-gallery-main",
      vertical: true,
      autoplay: false,
      centerMode: false,
      infinite: true,
      loop: true,
      swipe: false,
      swipeToSlide: false,
      touchMove: false,
      draggable: false,
    });
  }
  

  // jQuery(document).on('click', '.custom-featured-product-section.lp-featured-product .available-design .available-design-item', function () {
  //   var currentProduct_id = jQuery(this).attr('data-product-id')
  //   var currentProduct_title = jQuery(this).attr('data-product-name')
  //   jQuery(this).addClass('current')
  //   jQuery(' .available-design-item:not([data-product-id="' + currentProduct_id + '"])').removeClass('current')

  //   jQuery('.selected-design').text('(' + currentProduct_title + ')')

  //   jQuery('.product-wrapper[data-product-id="' + currentProduct_id + '"]').css({ 'height': 'auto', 'visibility': 'visible' })
  //   jQuery('.product-wrapper:not([data-product-id="' + currentProduct_id + '"])').css({ 'height': '0', 'visibility': 'hidden' })
  // });

  jQuery(".available-design-item").click(function () {
    var currentProduct_id = jQuery(this).attr("data-product-id");
    var currentProduct_title = jQuery(this).attr("data-product-name");
    jQuery(".available-design-item").css("border", "none");

    jQuery(
      '.available-design-item:not([data-product-id="' +
        currentProduct_id +
        '"])'
    ).css("border", "none");
    jQuery(
      '.available-design-item[data-product-id="' + currentProduct_id + '"]'
    ).css("border", "1px solid #481C2A");

    jQuery(".selected-design").text("(" + currentProduct_title + ")");

    jQuery('.product-wrapper[data-product-id="' + currentProduct_id + '"]').css(
      { height: "auto", visibility: "visible" }
    );
    jQuery(
      '.product-wrapper:not([data-product-id="' + currentProduct_id + '"])'
    ).css({ height: "0", visibility: "hidden" });
  });

  if (jQuery(".section-testimonial-slider .slider").length) {
    jQuery(".section-testimonial-slider .slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: false,
      infinite: false,
      loop: false,
      responsive: [
        {
          breakpoint: 0,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            centerMode: true,
            variableWidth: true,
            draggable: true,
          },
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            centerMode: true,
            variableWidth: true,
            draggable: true,
          },
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            centerMode: true,
          },
        },
      ],
    });
  }
  

  if (jQuery(".scroller-wrapper").length) {
    jQuery(".scroller-wrapper #moving").slick({
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: "linear",
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false,
      pauseOnHover: false,
    });
  }

  $(window).scroll(function () {
    var header = $(".shopify-section--header");
    var home_header = $(".page-index .shopify-section--header_new");
    var announcement = $(".shopify-section--announcement-bar");
    var window_offset = $(window).scrollTop();

    var lp_header = $("header.shopify-section--header_new.lp-header");

    if (window_offset >= 600) {
      home_header.addClass("sticky_header");
      lp_header.addClass("sticky_header");
      // hehome_headerader.css({ 'position': 'fixed', 'top': '39px' })
      announcement.css("position", "sticky");
    } else {
      home_header.removeClass("sticky_header");
      lp_header.removeClass("sticky_header");
      // home_header.css({ 'position': 'relative', 'top': '0' })
      announcement.css("position", "relative");
    }
  });

  if (jQuery("#movimg").length) {
    jQuery("#movimg").slick({
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: "linear",
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false,
      pauseOnHover: false,
    });
  }

  if (jQuery("#best-seller-movimg").length) {
    jQuery("#best-seller-movimg").slick({
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: "linear",
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false,
      pauseOnHover: false,
    });
  }
  

  if (jQuery(".bestseller-section .container .row").length) {
    jQuery(".bestseller-section .container .row").slick({
      slidesToShow: 1,
      autoplay: false,
      infinite: false,
      loop: false,
      arrows: true,
      dots: true,
      variableWidth: true,
      mobileFirst: true,
      centerMode: true,
      responsive: [
        {
          breakpoint: 768,
          settings: "unslick",
        },
      ],
    });
  }
  

  if (jQuery("section.shopify-section--icon-bar.lp--icon-bar .icon-bar__box .icon-bar__container:has(video)").length) {
    jQuery(
      "section.shopify-section--icon-bar.lp--icon-bar .icon-bar__box .icon-bar__container:has(video)"
    ).slick({
      slidesToShow: 1,
      autoplay: false,
      infinite: true,
      loop: true,
      arrows: false,
      dots: false,
      mobileFirst: true,
      centerMode: true,
      responsive: [
        {
          breakpoint: 768,
          settings: "unslick",
        },
      ],
    });
  }
  

  if (jQuery("section.shopify-section--icon-bar.lp--icon-bar .icon-bar__box .icon-bar__container:has(video)").length) {
    jQuery(
      "section.shopify-section--icon-bar.lp--icon-bar .icon-bar__box .icon-bar__container:has(video)"
    ).on("beforeChange", function (event, slick, currentSlide, nextSlide) {
      jQuery("video").each(function () {
        this.pause();
      });
    });
  }
  
  jQuery(document).on("click", "video", function () {
    this.paused ? this.play() : this.pause();
    var videoID = jQuery(this).attr("id");

    jQuery(this).toggleClass("playing");
    jQuery('video:not("#' + videoID + '")').removeClass("playing");

    jQuery("video:not(.playing)").trigger("pause");
  });

  const _comparisonSliders = jQuery(".js-col-slide").slick({
    slidesToShow: 1,
    arrows: false,
    dots: false,
    swipe: false,
    infinite: false,
    // variableWidth: true,
    // responsive: [
    //   {
    //     breakpoint: 768,
    //     settings: "unslick",
    //   },
    // ]
  });

  jQuery(".js-col-slide").on("afterChange", function () {
    jQuery(".js-comparison-prev").removeClass("disabled");
    jQuery(".js-comparison-next").removeClass("disabled");
    var dataId = jQuery(this).find(".slick-active").attr("data-slick-index");
    console.log(dataId);
    if (dataId == 0) {
      jQuery(".js-comparison-prev").addClass("disabled");
    } else if (dataId == 2) {
      jQuery(".js-comparison-next").addClass("disabled");
    }
  });

  jQuery(".js-comparison-next").click(function () {
    jQuery(".js-col-slide").slick("slickNext");
  });

  jQuery(".js-comparison-prev").click(function () {
    jQuery(".js-col-slide").slick("slickPrev");
  });

  if (jQuery(".custom-featured-product-section:not(.lp-featured-product) .product-slider-container.slider-container ").length) {
    jQuery(
      ".custom-featured-product-section:not(.lp-featured-product) .product-slider-container.slider-container "
    ).slick({
      speed: 5000,
      dots: true,
      autoplay: false,
      infinite: true,
      loop: true,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: true,
      dots: false,
      variableWidth: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }
  

  // const _buyBar = jQuery('.product-info__buy.sticky');

  // let isThrottled = false;

  // jQuery(window).on('scroll', function(){

  //   if (!isThrottled) {
  //     isThrottled = true;
  //     setTimeout(function () {
  //       // Your scroll-related code here
  //       if( scrollY < _buyBar.position().top ) {
  //         _buyBar.addClass('on');
  //       } else {
  //         _buyBar.removeClass('on');
  //       }
  //       isThrottled = false;
  //     }, 500);
  //   }
  // });

  const _buyBar = jQuery('.product-info__buy.sticky');

if (_buyBar.length) {
  const buyBarTop = _buyBar.offset().top; // safer than .position()

  jQuery(window).on('scroll', function () {
    window.requestAnimationFrame(() => {
      if (window.scrollY < buyBarTop) {
        _buyBar.addClass('on');
      } else {
        _buyBar.removeClass('on');
      }
    });
  });
}

  // jQuery('.js-variant').click(function(){
  //   const _class = jQuery(this).data('slug');
  //   const _item = jQuery('.js-gallery-main .gallery-item .' + _class);
  //   const _slide = _item.data('var');
  //   console.log('xxx');
  //   console.log( 'Yow', _class );
  //   _mainSlide.slick('slickGoTo', _slide);


  // });

  document.addEventListener("DOMContentLoaded", function () {
    let lastSubmitTime = 0;
    const submitDelay = 3000; // 3 seconds between submissions

    // Target both forms
    const forms = [
      document.querySelector('form[action="/contact"]'),
      document.querySelector('form[action="/localization"]')
    ].filter(Boolean); // remove nulls if not found

    forms.forEach(form => {
      form.addEventListener('submit', function (e) {
        const now = Date.now();
        if (now - lastSubmitTime < submitDelay) {
          e.preventDefault();
          alert("Please wait a few seconds before trying again.");
          return false;
        }
        lastSubmitTime = now;
      });
    });
  });

});
